export default __webpack_public_path__ + "static/media/qywx-github.fa096393.png";